const BASE_URL = '/nps/feedbacks';

export function fetchActiveCampaign() {
    return Hop.get(`${BASE_URL}/user/active`).then((response) => response.json());
}

// Hop.post could be used but we need keepalive param so that the request persists when changing / leaving page
function postFeedback(feedbackRequest) {
    return fetch(BASE_URL, {
        body: JSON.stringify(feedbackRequest),
        headers: {'Content-Type': 'application/json'},
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
    });
}

export function postDismiss() {
    return postFeedback({
        responsePath: window.location.pathname,
        isDismissal: true,
    });
}

export function postAnswer(score, comment) {
    return postFeedback({
        score,
        comment,
        responsePath: window.location.pathname,
        isDismissal: false,
    });
}
